import React, { Component } from "react";
import {
  getAll,
  deleteSingle,
  updateSingleStatus,
} from "../../services/visaService";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
import VisaTable from "./table";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import _ from "lodash";
import { Confirm } from "semantic-ui-react";
import TopStatus from "../common/topStatus";
import NotFound from "../common/notfound";
import ModuleFiltersAdvanced from "../common/moduleFiltersAdvanced";
import queryString from "query-string";

class Visas extends Component {
  state = {
    open: false,
    type: "",
    types: [],
    pageSize: 10,
    currentPage: 1,
    keyFieldValue: "",
    sortColumn: { path: "title", order: "asc" },
    noRecordFound: "",
    status: 1,
  };

  async componentDidMount() {
    document.body.style.backgroundImage = "none";
    const { keyword, status } = queryString.parse(this.props.location.search);

    this.setState({ blocking: true, show: "none" });
    const { data: types } = await getAll();
    this.checkTotalTypes(types);
    this.setState({
      types: types,
      blocking: false,
      keyFieldValue: keyword === undefined ? "" : keyword,
      status: status === undefined ? 1 : status,
    });
  }

  checkTotalTypes = (types) => {
    if (types.length > 0) {
      this.setState({ show: "none" });
    } else {
      this.setState({ show: "block" });
    }
  };

  handleDelete = (type) => {
    this.setState({ open: true, type });
  };

  doDelete = async () => {
    const type = this.state.type;
    const originalTypes = this.state.types;
    const types = originalTypes.filter((o) => o.id !== type.id);
    this.setState({ types, open: false });

    try {
      await deleteSingle(type.id);
      this.checkTotalTypes(types);
      toast.success("Account has been deleted successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This Account has already been deleted.");
      }

      this.setState({ types: originalTypes });
    }
  };

  handleUpdate = (type) => {
    return this.props.history.replace(
      "/visas-accounts/" +
        type.id +
        "/edit" +
        "?keyword=" +
        this.state.keyFieldValue +
        "&status=" +
        this.state.status
    );
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  handleSearching = (keyword, status) => {
    this.setState({
      keyFieldValue: keyword,
      currentPage: 1,
      status,
    });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleOnDetail = (type) => {
    return this.props.history.replace(
      "/visas-accounts/view/" +
        type.id +
        "?keyword=" +
        this.state.keyFieldValue +
        "&status=" +
        this.state.status
    );
  };

  handleInOut = (type) => {
    return this.props.history.replace(
      "/visas-accounts/in-out/" +
        type.id +
        "?keyword=" +
        this.state.keyFieldValue +
        "&status=" +
        this.state.status
    );
  };

  handleUpdateStatus = async (type) => {
    this.setState({ blocking: true });
    await updateSingleStatus(type);
    const { data: types } = await getAll();

    this.setState({ blocking: false, types: types });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      types: allTypes,
      keyFieldValue,
      sortColumn,
      status,
    } = this.state;

    let filtered = keyFieldValue
      ? allTypes.filter(
          (m) => m.name.toUpperCase().indexOf(keyFieldValue.toUpperCase()) > -1
        )
      : allTypes;

    filtered = filtered.filter((m) =>
      Number(status) === 2 ? m.cost === 0 : m.status === Number(status)
    );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const types = paginate(sorted, currentPage, pageSize);
    return { totalCount: filtered.length, data: types };
  };

  handleInputChange = (text) => {
    this.setState({
      keyFieldValue: text.target.value,
    });
  };

  handleReset = () => {
    this.setState({ keyFieldValue: "", status: 1 });
  };

  handleSelectChange = (select) => {
    this.setState({ status: select.target.value });
  };

  render() {
    const emtpyUrl = process.env.REACT_APP_URL + "/empty1.png";
    const { pageSize, currentPage, sortColumn, show } = this.state;
    const { totalCount, data: types } = this.getPagedData();
    const otherShow = show === "none" ? "block" : "none";
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/visa.png";

    if (this.state.types.length === 0 && this.state.blocking === false) {
      return (
        <NotFound
          title="Visas"
          linkTitle="Visa"
          link="/visas-accounts/new"
          button={true}
        />
      );
    }

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.open}
          header="Confirmation"
          content="Are you sure, you want to delete the account?"
          onCancel={this.handleCancel}
          onConfirm={this.doDelete}
          size="mini"
        />

        <h1 className="container__heading">Visas Accounts</h1>

        <article className="grid filters">
          <ModuleFiltersAdvanced
            onSearchButtonClick={this.handleSearching}
            addLink="/visas-accounts/new"
            addTitle="Visa"
            keyword={this.state.keyFieldValue}
            status={this.state.status}
            onInputChange={this.handleInputChange}
            onReset={this.handleReset}
            onSelectChange={this.handleSelectChange}
          />
        </article>

        <TopStatus count={totalCount} module="Accounts" />

        <VisaTable
          types={types}
          sortColumn={sortColumn}
          onDelete={this.handleDelete}
          onUpdate={this.handleUpdate}
          onSort={this.handleSort}
          onStatusUpdate={this.handleUpdateStatus}
          onDetail={this.handleOnDetail}
          onInOut={this.handleInOut}
        />
        <Pagination
          itemsCount={totalCount}
          pageSize={pageSize}
          onPageChange={this.handlePageChange}
          currentPage={currentPage}
        />
      </BlockUi>
    );
  }
}

export default Visas;
